import React from 'react';
import { useNavigate } from 'react-router-dom';

import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';

import InfoIcon from '@mui/icons-material/Info';

import { Layout } from 'src/styles';
import { getAzeiteOrOleoName } from 'src/utils/utils';

import AsmubipButton from './AsmubipButton';
import { useAppSelector } from 'src/app/hooks';

export default function AzeiteOrOleoNoResultsCard() {
  const navigate = useNavigate();
  const key = useAppSelector((state) => state.page.key);
  const azeiteOrOleoName = getAzeiteOrOleoName({ pageKey: key });
  return (
    <Card sx={Layout.mobileCard} variant="outlined">
      <CardContent sx={Layout.productionCardContent}>
        <Box sx={Layout.productionCardIconWrapper}>
          <InfoIcon sx={Layout.productionCardIcon} />
        </Box>
        <Box>Não há nenhuma produção de {azeiteOrOleoName} para este filtro!</Box>
      </CardContent>
      <CardActions>
        <AsmubipButton
          variant="contained-dark"
          size="large"
          sx={Layout.productionCardActionSingle}
          onClick={() => {
            navigate(`/${key}/create`);
          }}>
          Registrar nova produção
        </AsmubipButton>
      </CardActions>
    </Card>
  );
}
